var _path, _rect, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankyou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 158,
    viewBox: "0 0 168 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.3164 49.7205L167.163 79.5317L160.309 98.7205L97.9457 119.623L49.2884 111.741L27.0156 78.8463L99.3164 49.7205Z",
    fill: "#F9FFFF",
    stroke: "url(#paint0_linear_429_5007)",
    strokeWidth: 0.685315
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.8895,
    y: 24.7064,
    width: 100.056,
    height: 101.427,
    rx: 11.3077,
    fill: "url(#paint1_linear_429_5007)",
    stroke: "url(#paint2_linear_429_5007)",
    strokeWidth: 0.685315
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0145 137.441V79.0654L87.689 110.326C92.8409 112.981 98.9503 113.017 104.133 110.423L166.819 79.058V137.441C166.819 148.606 157.767 157.657 146.602 157.657H47.2313C36.0659 157.657 27.0145 148.606 27.0145 137.441Z",
    fill: "#E7EBFF",
    stroke: "url(#paint3_linear_429_5007)",
    strokeWidth: 0.685315
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6444 69.9004C73.3163 68.6112 72.6298 66.8962 72.5951 65.1695C72.5608 63.4432 73.1788 61.7011 74.4537 60.3586C75.7276 59.017 77.4242 58.3225 79.1318 58.2879C80.8404 58.2523 82.5629 58.8752 83.8919 60.1653L95.3661 71.3262L118.21 41.9918L119.029 42.6231L118.209 41.989C118.275 41.9034 118.349 41.8304 118.431 41.771C119.79 40.581 121.496 40.0438 123.163 40.1355V40.1336L123.245 40.1411C124.922 40.2534 126.56 41.0068 127.77 42.3713C129 43.7588 129.558 45.5211 129.465 47.2435H129.467L129.459 47.3259C129.35 48.9908 128.63 50.6179 127.326 51.8331L99.9105 85.5671L99.9123 85.5689C99.8609 85.6349 99.8031 85.6915 99.7401 85.7411C98.4565 86.8806 96.8354 87.4393 95.2235 87.4112C93.5982 87.3827 91.9762 86.758 90.7143 85.532L74.6444 69.9004Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.788 12.7699C163.024 13.2027 160.287 13.6009 158.606 14.9166C156.632 16.4573 156.164 19.2791 155.644 24.9226C155.107 19.0713 154.622 16.2669 152.456 14.7608C150.776 13.5836 148.056 13.2027 143.5 12.7872C148.247 12.3544 151.001 11.9563 152.664 10.6579C154.657 9.09987 155.124 6.2954 155.644 0.634521C156.129 5.8453 156.562 8.63246 158.173 10.2424C159.784 11.8524 162.591 12.3025 167.788 12.7699Z",
    fill: "url(#paint4_linear_429_5007)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6623 62.297C21.4325 62.7721 18.4278 63.2091 16.5831 64.6534C14.4151 66.3448 13.9016 69.4424 13.3311 75.6376C12.7416 69.2143 12.2091 66.1357 9.83194 64.4824C7.98727 63.1901 5.00155 62.7721 0 62.316C5.21074 61.8409 8.23449 61.4038 10.0602 59.9785C12.2471 58.2682 12.7606 55.1896 13.3311 48.9753C13.8636 54.6955 14.339 57.7551 16.1077 59.5224C17.8763 61.2898 20.9571 61.7839 26.6623 62.297Z",
    fill: "url(#paint5_linear_429_5007)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_429_5007",
    x1: 162.046,
    y1: 113.876,
    x2: 22.3862,
    y2: 27.5127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218356,
    stopColor: "#19309D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2443C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_429_5007",
    x1: 143.61,
    y1: 118.081,
    x2: 16.5913,
    y2: 79.4297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218356,
    stopColor: "#19309D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2443C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_429_5007",
    x1: 143.61,
    y1: 118.081,
    x2: 16.5913,
    y2: 79.4297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218356,
    stopColor: "#19309D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2443C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_429_5007",
    x1: 162.032,
    y1: 151.464,
    x2: 12.8261,
    y2: 70.1351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218356,
    stopColor: "#19309D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2443C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_429_5007",
    x1: 166.901,
    y1: 22.9259,
    x2: 136.349,
    y2: 13.5024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218356,
    stopColor: "#19309D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2443C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_429_5007",
    x1: 25.6889,
    y1: 73.4457,
    x2: -7.8502,
    y2: 63.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218356,
    stopColor: "#19309D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2443C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyou);
export default __webpack_public_path__ + "static/media/thankyou.623de084e7fa7966444662e2e366675f.svg";
export { ForwardRef as ReactComponent };